import React from 'react';
import { BRAND, FOOTER_DISCLAIMER, FOOTER_TAGLINE } from '../data/poolContent';
export function Footer() {
  return <footer className="w-full border-t border-abyss-600 bg-abyss-900 py-14" data-id="element-138" data-mp="3ggaovpzpm32t">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-139" data-mp="32oe1fz8zkhcr">
        <p className="font-display text-2xl font-bold tracking-[0.22em] text-frost-50" data-id="element-140" data-mp="32lrn9grlb3lk">{BRAND}</p>
        <p className="mt-2 text-[13px] font-medium uppercase tracking-[0.16em] text-aqua" data-id="element-141" data-mp="36nd6rkymqg4q">
          {FOOTER_TAGLINE}
        </p>

        <p className="mx-auto mt-8 max-w-2xl text-[12.5px] leading-relaxed text-muted" data-id="element-142" data-mp="38h81hlebwon">
          {FOOTER_DISCLAIMER}
        </p>

        <p className="mt-8 border-t border-abyss-600 pt-6 text-[12px] text-muted" data-id="element-143" data-mp="3ldkd52bd48p2">
          Copyright © {BRAND}. All rights reserved.
        </p>
      </div>
    </footer>;
}